/* eslint-disable @typescript-eslint/no-unused-vars */
import axios from "axios";
import Layout from "../../Components/Layout";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import { Editor } from "@tinymce/tinymce-react";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";
import { Category } from "../../types";

const EditorPage: React.FC = () => {
  const [value, setValue] = useState<string>("");
  const [section, setSection] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [categoryOptions, setCategoryOptions] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const editorRef = useRef<any>(null);

  const onEditorInputChange = (newValue: string, editor: any) => {
    setValue(newValue);
    setHtmlContent(editor.getContent());
  };

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/courses/v1/get-category`
      );

      setCategoryOptions(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const selectedCategory = categoryOptions.find(
        (option) => option.Category_Name === category
      );
      const categoryId = selectedCategory ? selectedCategory.Category_Id : "";
      const data = {
        section: section,
        content: htmlContent,
        category_id: categoryId,
      };

      console.log("data", data);
      const response = await AxiosInstance.post(
        `${BASE_API_URL}/admin/web-content/v1/course-content`,
        data
      );

      if (response.status === 200) {
        toast.success("Content submitted successfully");
      } else {
        toast.error("Something went wrong");
        console.log(response);
      }
      // Optionally, you can handle any further actions after successful submission
    } catch (error) {
      console.error("Error submitting content:", error);
    }
  };

  return (
    <Layout PageId={10}>
      <div className="max-w-3xl mx-auto p-6">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <div className="mb-4">
              <label
                htmlFor="category"
                className="block text-sm font-medium text-gray-700"
              >
                Category
              </label>
              <select
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:border-blue-500"
              >
                <option value="">Select Category</option>
                {loading ? (
                  <option disabled>Loading categories...</option>
                ) : (
                  categoryOptions.map((option) => (
                    <option
                      key={option.Category_Id}
                      value={option.Category_Name}
                    >
                      {option.Category_Name}
                    </option>
                  ))
                )}
              </select>
            </div>
            <label
              htmlFor="section"
              className="block text-sm font-medium text-gray-700"
            >
              Section Name
            </label>
            <input
              type="text"
              id="section"
              value={section}
              onChange={(e) => setSection(e.target.value)}
              className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:border-blue-500"
            />
          </div>

          <Editor
            apiKey={"2avudr9krr02tv4vx3n30lq44fz7w3d0qth7vz72z9oqnmqg"}
            onEditorChange={(newValue, editor) =>
              onEditorInputChange(newValue, editor)
            }
            initialValue={"Write your thoughts here..."}
            init={{
              plugins: [
                "advlist",
                "autolink",
                "lists",
                "link",
                "image",
                "charmap",
                "preview",
                "anchor",
                "searchreplace",
                "visualblocks",
                "code",
                "fullscreen",
                "insertdatetime",
                "media",
                "table",
                "code",
                "help",
                "wordcount",
              ],
              toolbar:
                "undo redo | blocks | " +
                "bold italic forecolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              branding: false,
              image_advtab: true,
              images_upload_url: "http://localhost:3000/upload",
              automatic_uploads: false, // Disable automatic uploads
              file_picker_types: "image",
              file_picker_callback: function (cb, value, meta) {
                // File picker callback for inserting images into the editor
                if (meta.filetype === "image") {
                  const input = document.createElement("input");
                  input.setAttribute("type", "file");
                  input.setAttribute("accept", "image/*");
                  const handleChange = function (
                    this: HTMLInputElement,
                    event: Event
                  ) {
                    const file = this.files && this.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = function (e) {
                        if (e.target) {
                          cb(e.target.result as string, {
                            alt: file.name,
                          });
                        }
                      };
                      reader.readAsDataURL(file);
                    }
                  };
                  input.addEventListener("change", handleChange);
                  input.click();
                }
              },
            }}
            ref={editorRef}
          />
          <div className="text-center">
            <button
              type="submit"
              className="bg-primary w-1/6 text-white px-4 py-2 rounded mt-4 hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
            >
              Submit
            </button>
          </div>
        </form>

        {/* <div className="browser-css mt-7">
          {parse(DOMPurify.sanitize(htmlContent))}
        </div> */}
      </div>
    </Layout>
  );
};

export default EditorPage;
